import React, { Component } from 'react';

import feedComparisonService from './feed-service';

import FeedDifferences from './feed-differences';
import MerchantDropdown from './merchant-dropdown';

import './feed-comparison.scss';

class FeedComparison extends Component {
  constructor(props) {
    super(props);

    this.service = feedComparisonService;
  }

  render() {
    const { merchantId } = this.props.match.params;
    const { fieldName } = this.props.match.params;

    return (
      <div className="feed-comparison">
        <h2>Feed Comparison</h2>
        <MerchantDropdown />
        <FeedDifferences merchantId={merchantId} fieldName={fieldName} match={this.props.match} />
      </div>
    );
  }
}

export default FeedComparison;
